import styled from 'styled-components';


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: #f9f9f9;
  padding: 20px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 800px;
  margin: 40px auto;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
  ;
  }
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: bold;
  color: #0f172a;
  margin-bottom: 16px;
`;

export const Paragraph = styled.p`
  color: #444;
  font-size: 16px;
  line-height: 1.5;
`;

export const Label = styled.label`
  font-size: 16px;
  color: #0f172a;
  font-weight: 600;
  margin-bottom: 6px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  background: #f6f6f6;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  background: #f6f6f6;
  min-height: 80px;
`;

export const Button = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  background: #0066ff;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    background: #0052cc;
  }
`;

export const StepControls = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
`;

export const AddMore = styled.button`
  background: none;
  border: none;
  color: #0066ff;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 0;
  &:hover {
    text-decoration: underline;
  }
`;
